import {MapDifficultyLevel, SOUTH_AMERICA_COUNTRIES} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
// "Argentina","Bolivia","Brazil","Chile","Colombia","Ecuador","Falkland Islands","French Guiana","Guyana","Paraguay","Peru","Suriname","Uruguay","Venezuela",
//   ]) {
//     console.log(name);
//     const country = ALL_COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class SouthAmericaDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<SouthAmericaDifficultyLevel>(1);
  static readonly MEDIUM = SouthAmericaDifficultyLevel.VALUES[0] = new SouthAmericaDifficultyLevel("medium", "Medium", "Medium desc", SOUTH_AMERICA_COUNTRIES);
}